import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useVideoDetail, useVideoEmoji } from '../../../commons/customHooks/Video';
import VideoDetailComponent from '../components/detail/videoDetail';
import * as action from '../redux/actions/';

const VideoDetailPageContainer = () => {
  const paramUrl = useParams();

  const [params, setParams] = useState({
    id: paramUrl.id
  })
  const [videoDetail, isProcessing, isProcessingDel] = useVideoDetail(params);

  const [videoEmoji, isProcessingEmoji] = useVideoEmoji(null);

  const {isProcessingTitle} = useSelector((state) => state.videoDetailReducers);

  return <VideoDetailComponent 
    videoDetail={videoDetail}
    isProcessing={isProcessing}
    updateVideo={action.updateVideoRequest}
    videoEmoji={videoEmoji}
    isProcessingEmoji={isProcessingEmoji}
    deleteVideo={action.deleteVideoRequest}
    isProcessingTitle={isProcessingTitle}
    isProcessingDel={isProcessingDel}
  />;
};

export default memo(VideoDetailPageContainer);
